/**
 * DevExtreme (ui/scheduler/dataStructures.js)
 * Version: 20.2.3
 * Build date: Tue Oct 20 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
exports.AppointmentTooltipInfo = void 0;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function")
    }
}
var AppointmentTooltipInfo = function AppointmentTooltipInfo(appointment) {
    var targetedAppointment = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
    var color = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
    var settings = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
    _classCallCheck(this, AppointmentTooltipInfo);
    this.appointment = appointment;
    this.targetedAppointment = targetedAppointment;
    this.color = color;
    this.settings = settings
};
exports.AppointmentTooltipInfo = AppointmentTooltipInfo;
